import { render, staticRenderFns } from "./SalesPerson.vue?vue&type=template&id=04c8cafc&"
import script from "./SalesPerson.vue?vue&type=script&lang=ts&"
export * from "./SalesPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports